import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=3ed2a89d&scoped=true&"
var script = {}
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=3ed2a89d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2a89d",
  null
  
)

export default component.exports